module.exports = __webpack_public_path__ + "image/pop-pic.png";